import { render, staticRenderFns } from "./GeneralSettingsFooterLayout.vue?vue&type=template&id=fadb751a&scoped=true&"
import script from "./GeneralSettingsFooterLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsFooterLayout.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsFooterLayout.vue?vue&type=style&index=0&id=fadb751a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadb751a",
  null
  
)

export default component.exports